module.exports = __webpack_public_path__ + "img/4.2208516b.jpg";